const
    CatalogEngineReady = 'CatalogEngineReady',
    CategoriesFetched = 'CategoriesFetched',
    CertonaCtrlrsApplied = 'CertonaCtrlrsApplied',
    CertonaFailed = 'CertonaFailed',
    CertonaLoaded = 'CertonaLoaded',
    CertonaReady = 'CertonaReady',
    ConstructorBeaconDisabled = 'ConstructorBeaconDisabled',
    ConstructorBeaconInitialized = 'ConstructorBeaconInitialized',
    DebouncedResize = 'DebouncedResize',
    DebouncedScroll = 'DebouncedScroll',
    DOMContentLoaded = 'DOMContentLoaded',
    HydrationFinished = 'HydrationFinished',
    Immediate = 'Immediate',
    ImmediateReady = 'ImmediateReady',
    InPageCompsCtrlrsApplied = 'InPageCompsCtrlrsApplied',
    LazyLoadComplete = 'LazyLoadComplete',
    load = 'load',
    OrderInfoCtrlrsApplied = 'OrderInfoCtrlrsApplied',
    OrderInfoLoaded = 'OrderInfoLoaded',
    OrderInfoReady = 'OrderInfoReady',
    PageRendered = 'Page Rendered',
    PostLoad = 'PostLoad',
    PostLoadCtrlrsApplied = 'PostLoadCtrlrsApplied',
    ProfileUpdated = 'ProfileUpdated',
    SearchInfoLoaded = 'SearchInfoLoaded',
    SearchInfoReady = 'SearchInfoReady',
    ShowQuickLookModal = 'ShowQuickLookModal',
    TestTarget = 'TestTarget',
    TestTargetCtrlrsApplied = 'TestTargetCtrlrsApplied',
    TestTargetLoaded = 'TestTargetLoaded',
    TestTargetReady = 'TestTargetReady',
    TestTargetResult = 'TestTargetResult',
    TestTargetServiceReady = 'TestTargetServiceReady',
    UserInfoCtrlrsApplied = 'UserInfoCtrlrsApplied',
    UserInfoLoaded = 'UserInfoLoaded',
    UserInfoReady = 'UserInfoReady',
    VisitorAPILoaded = 'VisitorAPILoaded',
    nebOnsiteLoaded = 'neb_OnsiteLoaded';


// This function should run immediately the first time its called.
// It will then run at the specified interval if called again
// before that interval is up.
function debounce(func, wait, immediate) {
    var lastRun,
        timeout,
        args,
        _this,
        later = function () {
            clearTimeout(timeout);
            timeout = null;
            lastRun = new Date().getTime();
            func.apply(_this, args);
        };

    return function () {
        /* eslint-disable no-invalid-this */
        _this = this;
        args = arguments;

        var sinceLastRun = new Date().getTime() - lastRun;
        if (sinceLastRun > wait) {
            later();
        } else if (!timeout) {
            timeout = setTimeout(later, wait - sinceLastRun);
        }
    };
}

var debouncedScrollHandler = debounce(function () {
    window.dispatchEvent(new CustomEvent(DebouncedScroll, { detail: {} }));
}, 50, true);

window.addEventListener('scroll', debouncedScrollHandler);

var debouncedResizeHandler = debounce(function () {
    window.dispatchEvent(new CustomEvent(DebouncedResize, { detail: {} }));
}, 500, true);

window.addEventListener('resize', debouncedResizeHandler);

var services = window.Sephora.Util.InflatorComps.services;

// const onLast = function (target, events, callback) {
//     var count = 0;
//
//     for (var i = 0; i < events.length; i++) {
//         target.addEventListener(events[i], function () {
//             if (++count === events.length) callback();
//         }, false);
//     }
// }

module.exports = {
    CatalogEngineReady,
    CategoriesFetched,
    CertonaCtrlrsApplied,
    CertonaFailed,
    CertonaLoaded,
    CertonaReady,
    ConstructorBeaconDisabled,
    ConstructorBeaconInitialized,
    DebouncedResize,
    DebouncedScroll,
    DOMContentLoaded,
    HydrationFinished,
    Immediate,
    InPageCompsCtrlrsApplied,
    LazyLoadComplete,
    load,
    onLastLoadEvent: Sephora.Util.onLastLoadEvent,
    OrderInfoCtrlrsApplied,
    OrderInfoLoaded,
    OrderInfoReady,
    PostLoad,
    PostLoadCtrlrsApplied,
    ProfileUpdated,
    SearchInfoLoaded,
    SearchInfoReady,
    ShowQuickLookModal,
    nebOnsiteLoaded,
    TestTarget,
    TestTargetCtrlrsApplied,
    TestTargetLoaded,
    TestTargetReady,
    TestTargetResult,
    TestTargetServiceReady,
    UserInfoCtrlrsApplied,
    UserInfoLoaded,
    UserInfoReady,
    VisitorAPILoaded
};
